import { v4 as uuidv4 } from 'uuid';
import { JSONSchema7 } from 'json-schema';
import ControlKind from '../../../Shared/controlKind';
import { SelectSubtypes } from '../types';
import { GridSize } from '../../../Shared/Enums/gridSize';
import { OptionOrientation } from '../../../Shared/Enums/optionOrientation';

export default (controlId: string, pageExternalId: string, order: number) => {
  return {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $id: `#${pageExternalId}/${controlId}`,
    type: 'object',
    properties: {
      version: {
        $id: `#${pageExternalId}/${controlId}/version`,
        default: 7,
        type: 'number'
      },
      type: {
        $id: `#${pageExternalId}/${controlId}/type`,
        default: ControlKind.SELECT,
        type: 'string'
      },
      label: {
        $id: `#${pageExternalId}/${controlId}/label`,
        default: 'Select Label',
        type: 'string'
      },
      id: {
        $id: `#${pageExternalId}/${controlId}/id`,
        default: `${uuidv4().replace(/-/g, '')}`,
        type: 'string'
      },
      subType: {
        $id: `#${pageExternalId}/${controlId}/subType`,
        type: 'string',
        default: SelectSubtypes.SINGLE_DROPDOWN,
        enum: [SelectSubtypes]
      },
      options: {
        $id: `#${pageExternalId}/${controlId}/options`,
        type: 'array',
        minItems: 1,
        default: [
          { value: 'Value1', id: 'Value1', status: '', utilize: '' },
          { value: 'Value2', id: 'Value2', status: '', utilize: '' }
        ]
      },
      value: {
        $id: `#${pageExternalId}/${controlId}/value`,
        default: '',
        type: 'string'
      },
      required: {
        $id: `#${pageExternalId}/${controlId}/required`,
        default: false,
        type: 'boolean'
      },
      order: {
        $id: `#${pageExternalId}/${controlId}/order`,
        default: order,
        type: 'integer'
      },
      statusEnabled: {
        $id: `#${pageExternalId}/${controlId}/statusEnabled`,
        default: false,
        type: 'boolean'
      },
      conditional: {
        $id: `#${pageExternalId}/${controlId}/conditional`,
        default: false,
        type: 'boolean'
      },
      utilizeHiddenComponents: {
        $id: `#${pageExternalId}/${controlId}/utilizeHiddenComponents`,
        default: false,
        type: 'boolean'
      },
      gridSize: {
        $id: `#${pageExternalId}/${controlId}/gridSize`,
        default: GridSize.FULL,
        type: 'number'
      },
      optionOrientation: {
        $id: `#${pageExternalId}/${controlId}/optionOrientation`,
        default: OptionOrientation.VERTICAL,
        type: 'string'
      }
    }
  } as JSONSchema7;
};
